import React from "react";
import Carousel from "react-material-ui-carousel";
import { Card, Typography, Container } from "@mui/material";

export function TestimonialCarousel(props) {
  const items = [
    {
      name: "Jeffrey",
      description:
        "A little over a year ago, I was crossing the street and was struck by a vehicle. I sustained very serious injuries. A friend recommended Mr. Russell and he met with me the day I was discharged from the hospital. I was about to start a long stay at the rehabilitation facility. I will try to make this brief, because this is very emotional for me. Ed not only became my attorney at that moment, he became my advocate and friend. Mr. Russell did a wonderful job. It could not have been done better. He has every reason to be proud of himself. Everything turned out as well as could be expected. Ed produced our result and he did it strictly by the rules. I will always be in Mr. Russell's debt. I will always have a valued friend.",
    },
    {
      name: "Sarah",
      description:
        "I want to express my sincerest gratitude for the assistance Ed gave me and my family.  While at a large theme park, I slipped and fell, and my daughter also slipped and fell on top of me.  I was five months pregnant at the time and went immediately to the hospital.  My medical bills were very expensive, because I didn’t have insurance at the time.  When I approached the theme park, they explained I had assumed the risk, simply by walking in the theme park between attractions.  Ed explained that the law in Texas was on my side and he was able to get my medical bills covered plus extra for what we had to go through.",
    },
    {
      name: "Steve",
      description:
        "Maybe someone will read this and be impacted by my experiences over the last 3 months.  Maybe someone will feel what I have pondered over saying, even though writing is something that I rarely do.  I was in a wreck.  A bad wreck.  A head on wreck.  When the dust settled, and I got the hospital bills, the broken bones weren’t the worst.  I am not well off.  I didn’t have health insurance.  I was scared.  What this man did for me was absolutely amazing.  I am now no longer worried about possible future surgeries, or where I will get money to pay for things.  Whew.  That was a lot for me to express, and if it reaches someone….I’ve done my part.  Please consider Ed Russell Law when something out of your control happens, and when you need someone who is absolutely devoted to helping his clients.",
    },
  ];

  return (
    <Carousel
      interval="40000"
      animation="slide"
      indicators={false}
      navButtonsAlwaysVisible={{ xs: false, md: true }}
      sx={{
        margin: { xs: "none", md: "20px 0px" },
        padding: { xs: "none", md: "20px 0px" },
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: { xs: "1000px", md: "300px" },
      }}
    >
      {items.map((item, i) => (
        <Container key={item.name} sx={{ margin: "20px, 0px", height: "fit-content" }}>
          <Item
            key={item.name}
            item={item}
            sx={{ padding: "20px 0px", height: "fit-content" }}
          />
        </Container>
      ))}
    </Carousel>
  );
}

function Item(props) {
  return (
    <Card sx={{ height: "fit-content", padding: "10px" }}>
      <Container sx={{ height: "fit-content", margin: "20px, 0px" }}>
        <Typography variant="h4">{props.item.name}</Typography>
        <br></br>
        <Typography
          variant="body"
          sx={{ fontSize: "16pt" }}
        >{`"${props.item.description}"`}</Typography>
      </Container>
    </Card>
  );
}
